import axiosInstance from "./axiosInstance";

const DonationService = {
  getDonations: () => axiosInstance.get("/api/donations/"),
  getDonation: (id) => axiosInstance.get(`/api/donations/${id}/`),
  createDonation: (data, file) => {
    const formData = new FormData();
    formData.append("donor_name", data.donor_name || "");
    formData.append("amount_label", data.amount_label || "");
    formData.append("amount", data.amount || "");
    formData.append("order", data.order || 0);
    formData.append("description", data.description || "");
    formData.append("language", data.language || "");
    formData.append("financial_year", data.financial_year || "");

    if (file) {
      formData.append("image", file);
    }

    console.debug(
      "DonationService.createDonation FormData:",
      Array.from(formData.entries()).map(([k, v]) => [k, v.name || v])
    );
    return axiosInstance.post("/api/donations/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
  updateDonation: (id, data, file) => {
    if (file) {
      const formData = new FormData();
      formData.append("donor_name", data.donor_name || "");
      formData.append("amount_label", data.amount_label || "");
      formData.append("amount", data.amount || "");
      formData.append("order", data.order || 0);
      formData.append("description", data.description || "");
      formData.append("language", data.language || "");
      formData.append("financial_year", data.financial_year || "");
      formData.append("image", file);

      console.debug(
        "DonationService.updateDonation FormData:",
        Array.from(formData.entries()).map(([k, v]) => [k, v.name || v])
      );
      return axiosInstance.patch(`/api/donations/${id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    }

    // No file - send JSON with keep_image flag
    const payload = { ...data, keep_image: true };
    console.debug("DonationService.updateDonation JSON:", payload);
    return axiosInstance.patch(`/api/donations/${id}/`, payload);
  },
  deleteDonation: (id) => axiosInstance.delete(`/api/donations/${id}/`),
};

export default DonationService;
